import { Tooltip as TooltipPrimitive } from "radix-ui";
import type { ComponentProps, ReactNode } from "react";

import { cn } from "@/lib/utils";

export function TooltipProvider({
  children,
  delayDuration = 400,
  ...props
}: ComponentProps<typeof TooltipPrimitive.Provider>) {
  return (
    <TooltipPrimitive.Provider delayDuration={delayDuration} {...props}>
      {children}
    </TooltipPrimitive.Provider>
  );
}

function TooltipContent({
  className,
  sideOffset = 4,
  children,
  ...props
}: ComponentProps<typeof TooltipPrimitive.Content>) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        sideOffset={sideOffset}
        className={cn(
          "bg-popover text-popover-foreground border-border z-[200] max-w-xs whitespace-normal rounded-md border px-3 py-2 text-xs leading-relaxed shadow-md",
          className,
        )}
        {...props}
      >
        {children}
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  );
}

/** Small dotted underline; hover / focus shows `description`. */
export function HelpTooltip({
  label,
  description,
  className,
}: {
  label: ReactNode;
  description: string;
  className?: string;
}) {
  return (
    <TooltipPrimitive.Root>
      <TooltipPrimitive.Trigger asChild>
        <span
          tabIndex={0}
          className={cn(
            "cursor-help underline decoration-muted-foreground/70 decoration-dotted underline-offset-2",
            className,
          )}
        >
          {label}
        </span>
      </TooltipPrimitive.Trigger>
      <TooltipContent>{description}</TooltipContent>
    </TooltipPrimitive.Root>
  );
}
